import { Input } from 'antd';
import React, { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useDebounce } from '../../hooks/useDebounce';

export const ProductSearch: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState(searchParams.get('q') || '');

  const updateUrl = useCallback(
    (input: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (input.length >= 3) {
            next.set('q', input);
          } else {
            next.delete('q');
          }
          next.delete('page');
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const debouncedUpdateUrl = useDebounce(updateUrl, 400);

  const handleChange = useCallback(
    (input: string) => {
      setValue(input);
      debouncedUpdateUrl(input);
    },
    [debouncedUpdateUrl],
  );

  return (
    <Input
      placeholder="Пошук за назвою (мін. 3 символи)"
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      allowClear
      style={{ width: 260 }}
    />
  );
};
